module.exports = __webpack_public_path__ + "static/media/grin-beam.0e463227.svg";